import React from 'react';
import { connect } from 'redux-bundler-react';
import { SidebarButton } from '../../application-controls/index';

class ZoomInButton extends React.Component {
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    const { doZoomIn } = this.props;
    doZoomIn();
  }

  render() {
    return (
      <SidebarButton
        iconClass="mdi mdi-plus"
        label="Zoom In"
        title="Zoom In"
        onClick={ this.handleClick }
      />
    );
  }
}

export default connect(
  'doZoomIn',
  ZoomInButton
);